import React, { ReactNode } from 'react'

export type ILoadingCard = {children: ReactNode, className?: string } & React.HTMLAttributes<HTMLDivElement>
export const LoadingCard = ({ children, className, ...rest }: ILoadingCard) =>
  <div className={`loading-card ${className || ''}`} {...rest}>{children}</div>
